import { Controller } from "@hotwired/stimulus";

// A modal that asks once before a permanent delete. Cancel takes focus when it
// opens (autofocus in the markup), so pressing Enter by reflex backs out
// instead of deleting.
export default class extends Controller {
  static targets = ["dialog"];

  open() {
    this.dialogTarget.showModal();
  }

  close() {
    if (this.dialogTarget.open) this.dialogTarget.close();
  }

  cancel(event) {
    event.preventDefault();
    this.close();
  }
}
